import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MAT_DATE_FORMATS, DateAdapter, NativeDateAdapter } from '@angular/material/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { environment } from '../environments/environment';
import { JwtModule } from "@auth0/angular-jwt";
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UtilisateurModule } from './components/utilisateur/utilisateur.module';
import { DashboardModule } from './components/dashboard/dashboard.module';
import { CommandeModule } from './components/commande/commande.module';
import { TarifModule } from './components/tarif/tarif.module';
import { TokenInterceptorService } from './core/services/tokenInterceptor.service';
import { AuthGuard } from './core/services/auth-guard.service';
import { ZoneModule } from './components/zone/zone.module';
import { SharedModule } from './shared/shared.module';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { ParametresComponent } from './components/parametres/parametres.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { GestionRolesComponent } from './components/gestion-roles/gestion-roles.component';
import { ProfilComponent } from './components/profil/profil.component';
import { LivreurModule } from './components/livreur/livreur.module';
import { SuiviPublicComponent } from './components/public/suivi-public/suivi-public.component';
import { ListePartenairesComponent } from './components/partenaires/liste/liste-partenaires.component';
import { GestionPartenaireComponent } from './components/partenaires/gestion/gestion-partenaire.component';
import { CommandesInterurbainesComponent } from './components/commande/interurbain/commandes-interurbaines.component';
import { DashboardZoneManagerComponent } from './components/dashboard/zone-manager/dashboard-zone-manager.component';
import { ListeManifestesComponent } from './components/manifeste/liste/liste-manifestes.component';
import { DepotageComponent } from './components/commande/depotage/depotage.component';
import { ClientDetailComponent } from './components/clients/detail/client-detail.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { DashboardComptableComponent } from './components/dashboard/comptable/dashboard-comptable.component';
import { RapportsModule } from './components/rapports/rapports.module';
import { GestionVillesComponent } from './components/configuration/villes/gestion-villes.component';
import { ListeCentresTriComponent } from './components/configuration/centres-tri/liste-centres-tri.component';
import { TypesConditionnementComponent } from './components/configuration/types-conditionnement/types-conditionnement.component';
import { ListeDevisComponent } from './components/devis/liste-devis.component';
import { GestionFaqComponent } from './components/configuration/faq/gestion-faq.component';
import { ListeClientsComponent } from './components/clients/liste/liste-clients.component';

registerLocaleData(localeFr, 'fr');

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthDayA11yLabel: 'DD MMMM',
  },
};

export function tokenGetter() {
  return localStorage.getItem('dematral_token');
}

@NgModule({
  declarations: [
    AppComponent,
    SuiviPublicComponent,
    AdminLayoutComponent,
    ParametresComponent,
    NotificationsComponent,
    GestionRolesComponent,
    ProfilComponent,
    ListePartenairesComponent,
    GestionPartenaireComponent,
    CommandesInterurbainesComponent,
    DashboardZoneManagerComponent,
    ListeManifestesComponent,
    DepotageComponent,
    ClientDetailComponent,
    DashboardComptableComponent,
    GestionVillesComponent,
    ListeCentresTriComponent,
    TypesConditionnementComponent,
    ListeDevisComponent,
    GestionFaqComponent,
    ListeClientsComponent
  ],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatDatepickerModule,
    MatSnackBarModule,
    DashboardModule,
    UtilisateurModule,
    CommandeModule,
    TarifModule,
    ZoneModule,
    LivreurModule,
    RapportsModule,
    SharedModule,
    NgxEchartsModule.forRoot({ echarts: () => import('echarts') }),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        allowedDomains: [environment.domain],
        disallowedRoutes: [
          `${environment.apiurl}auth/login`,
          `${environment.apiurl}auth/register`,
          `${environment.apiurl}/expediteurs`,
          `${environment.apiurl}/destinataires`,
        ]
      }
    })
  ],
  providers: [
    AuthGuard,
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
    {
      provide: DateAdapter,
      useClass: NativeDateAdapter
    },
     {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { } 
